import { Badge, Grid } from '@material-ui/core';
import React from 'react';
import { styles } from './force-exchange-component-styles';
import { ReactComponent as CheckMark } from '../../common/media/Checkmark.svg';
import { convertCurrency } from '../../common/helpers/currency-helper';

export interface ListItemProp {
  handleSelection: any;
  selectedLines?: number[];
  managerOverride: boolean;
  thresholdOverride: boolean;
  description: string;
  amount: number | undefined;
  itemId?: string;
  index: number;
  quantity?: number;
  thresholdSelected?: boolean;
}

const ExchangeListItem: React.FC<ListItemProp> = ({
  handleSelection,
  selectedLines,
  managerOverride,
  thresholdOverride,
  description,
  amount,
  itemId,
  index,
  quantity,
  thresholdSelected,
}): JSX.Element => {
  const classes = styles();
  return (
    <Grid item className={!(managerOverride || thresholdOverride) ? classes.disabledLineItem : ''}>
      <Badge
        anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
        showZero={true}
        badgeContent={
          (managerOverride && selectedLines?.includes(index)) ||
          (thresholdOverride && thresholdSelected) ? (
            <CheckMark />
          ) : (
            ''
          )
        }
        className={classes.badge}
      >
        {' '}
      </Badge>
      <Grid
        item
        data-testid={`force-exchange-click-${itemId || 'threshold'}`}
        className={`${classes.resultsItem} ${classes.customMargin} ${
          (managerOverride && selectedLines?.includes(index)) ||
          (thresholdOverride && thresholdSelected)
            ? `${classes.selected}`
            : ''
        }`}
        onClick={
          managerOverride && index !== -1
            ? (): void => handleSelection(index)
            : thresholdOverride
            ? () => handleSelection()
            : () => {}
        }
      >
        <Grid
          container
          className={`fullHeight`}
          justifyContent='space-between'
          alignContent='center'
        >
          <Grid
            xs={8}
            className={classes.leftAlign}
            data-testid='force-exchange-list-description'
            item
          >
            {description}
          </Grid>
          {!thresholdOverride ? (
            <Grid xs={1} item data-testid='force-exchange-list-qty'>
              {quantity}
            </Grid>
          ) : (
            <Grid />
          )}
          <Grid
            xs={thresholdOverride ? 4 : 3}
            className={classes.rightAlign}
            item
            data-testid='force-exchange-list-amount'
          >
            {convertCurrency(amount ?? 0)}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ExchangeListItem;
